module.exports = __webpack_public_path__ + "static/media/Sad.6baa427c.png";